module.exports = __webpack_public_path__ + "media/images/close-b117479f46c0393b534040db76a42098.svg";